// http://necolas.github.io/react-native-web/docs/iframe.html?id=guides-web-recipes--page&viewMode=docs#hover-styles

import React, { useState, memo } from 'react';
import { isHoverEnabled } from './hoverState';

/**
 * @typedef {object} HoverableProps
 * @property {(isHovered: boolean) => React.ReactNode} children
 * @property {() => void} [onHoverIn]
 * @property {() => void} [onHoverOut]
 */

/** @type {React.FC<HoverableProps>} */
export const Hoverable = memo(({ children, onHoverIn, onHoverOut }) => {
  const [showHover, setShowHover] = useState(true);
  const [isHovered, setIsHovered] = useState(false);

  const _handleMouseEnter = (e) => {
    if (isHoverEnabled() && !isHovered) {
      onHoverIn && onHoverIn();
      setIsHovered(true);
    }
  };
  const _handleMouseLeave = (e) => {
    if (isHovered) {
      onHoverOut && onHoverOut();
      setIsHovered(false);
    }
  };
  const _handleGrant = () => {
    setShowHover(false);
  };
  const _handleRelease = () => {
    setShowHover(true);
  };

  const child =
    typeof children === 'function'
      ? children(showHover && isHovered)
      : children;

  return React.cloneElement(React.Children.only(child), {
    onMouseEnter: _handleMouseEnter,
    onMouseLeave: _handleMouseLeave,
    // prevent hover showing while responder
    onResponderGrant: _handleGrant,
    onResponderRelease: _handleRelease,
    // if child is Touchable
    onPressIn: _handleGrant,
    onPressOut: _handleRelease,
  });
});
